/* istanbul ignore file */ /* plugin extension code */

import 'requestidlecallback-polyfill';

export const intlPolyfill = () => {
  fixReanimatedFrameTimestamp();
};

// ─────────────────────────────────────────────────────────────────────────────

/**
 * @see {@link: https://github.com/software-mansion/react-native-reanimated/issues/3355}
 */
function fixReanimatedFrameTimestamp() {
  (window as unknown as { _frameTimestamp: unknown })._frameTimestamp = null;
}
